export const PRODUCT_TYPE_SIMPLE = 0;
export const PRODUCT_TYPE_DEAL_COMBO = 1;
export const PRODUCT_TYPE_MEAL_COMBO = 2;

export const PRODUCT_TYPES_WITH_CASHBACK = [PRODUCT_TYPE_SIMPLE, PRODUCT_TYPE_MEAL_COMBO]
